import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Eye, EyeOff } from "lucide-react";

export default function Register() {
  const { register, error } = useAuth();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await register(email, password, name);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white kw-bg-grid p-6">
      <form onSubmit={submit} className="w-full max-w-sm kw-card p-8 kw-fade-up" data-testid="register-form">
        <div className="kw-overline mb-2">Novo consultor</div>
        <h2 className="font-display text-3xl font-black uppercase mb-8 tracking-tight">Criar conta</h2>

        <label className="kw-overline block mb-2">Nome</label>
        <input data-testid="reg-name" className="kw-input mb-4" value={name} onChange={(e) => setName(e.target.value)} required />

        <label className="kw-overline block mb-2">Email</label>
        <input data-testid="reg-email" type="email" className="kw-input mb-4" value={email} onChange={(e) => setEmail(e.target.value)} required />

        <label className="kw-overline block mb-2">Password</label>
        <div className="relative mb-4">
          <input data-testid="reg-password" type={showPassword ? "text" : "password"} className="kw-input !pr-11 w-full" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button type="button" onClick={() => setShowPassword((s) => !s)} className="absolute inset-y-0 right-3 flex items-center text-[#737373] hover:text-white" tabIndex={-1} aria-label={showPassword ? "Ocultar password" : "Mostrar password"} data-testid="reg-password-toggle">
            {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        </div>

        {error && (
          <div className="mb-4 p-3 border border-[#E50000]/50 bg-[#E50000]/10 text-[#FF6B6B] text-sm">{error}</div>
        )}

        <button type="submit" disabled={loading} className="kw-btn-primary w-full" data-testid="reg-submit">
          {loading ? "A criar…" : "Criar conta"}
        </button>

        {/* REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */}
        <div className="my-4 flex items-center gap-3 text-[10px] uppercase tracking-widest text-[#737373]">
          <div className="flex-1 h-px bg-[#222]" /> ou <div className="flex-1 h-px bg-[#222]" />
        </div>
        <button
          type="button"
          onClick={() => {
            const redirectUrl = window.location.origin + "/auth/callback";
            window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
          }}
          className="w-full border border-[#222] hover:border-white text-white font-bold uppercase tracking-widest text-xs py-3 inline-flex items-center justify-center gap-2 transition-colors"
          data-testid="reg-google">
          <svg className="w-4 h-4" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.1A6.5 6.5 0 0 1 5.5 12c0-.73.12-1.44.34-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.78.43 3.47 1.18 4.96l3.66-2.86z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.46 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
          </svg>
          Entrar com Google
        </button>

        <div className="mt-6 text-sm text-[#A3A3A3] text-center">
          Já tem conta?{" "}
          <Link to="/login" className="text-[#E50000] hover:underline font-semibold">Entrar</Link>
        </div>
      </form>
    </div>
  );
}
